/*  ========================================================================
    # Sections - Subscriptions
    ========================================================================  */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ExpandableImage from '../../components/ExpandableImage/ExpandableImage';
import Subscription from '../../components/Subscription';

const Subscriptions = ({ title, stageDescription, stageImage, subscriptions }) => {
  const articleRef = useRef(null);
  const sidebarRef = useRef(null);

  const handleKeyDown = e => {
    // Handle keyboard navigation for accessibility
    if (e.key === 'ArrowRight') {
      sidebarRef.current.focus();
    } else if (e.key === 'ArrowLeft') {
      articleRef.current.focus();
    }
  };

  return (
    <div className='container'>
      <div className='s-subscriptions__wrapper' onKeyDown={e => handleKeyDown(e)}>
        {title && <h2>{title}</h2>}
        <div className='row'>
          <article className='col-full lg:col-8/12' tabIndex={0} ref={articleRef}>
            <div className='s-subscriptions__items'>
              {subscriptions.map((subscription, index) => (
                <div className='s-subscriptions__item' key={index}>
                  <Subscription {...subscription} />
                </div>
              ))}
            </div>
          </article>
          <aside className='col-full lg:offset-1/12 lg:col-3/12' tabIndex={0} ref={sidebarRef}>
            <div className='s-subscriptions__sidebar'>
              {stageImage && (
                <ExpandableImage image={stageImage} classes='s-subscriptions__image' />
              )}
              {stageDescription && (
                <div dangerouslySetInnerHTML={{ __html: stageDescription }}></div>
              )}
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

Subscriptions.propTypes = {
  title: PropTypes.string,
  stageDescription: PropTypes.string,
  stageImage: PropTypes.object,
  subscriptions: PropTypes.array
};

export default Subscriptions;
